import { render, staticRenderFns } from "./AuthenticateSecurity.vue?vue&type=template&id=5b87c020&"
import script from "./AuthenticateSecurity.vue?vue&type=script&lang=ts&"
export * from "./AuthenticateSecurity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports